// src/constants/options.ts - ZAKTUALIZOWANE CENY ZGODNIE Z WYMAGANIAMI
import { 
  FileText, 
  Palette, 
  Sparkles, 
  Package, 
  Lightbulb, 
  Zap, 
  Lock, 
  Link, 
  Droplets,
  Type,
  Layers,
  Shield,
  CircleDot
} from 'lucide-react';

export interface AdditionalOption {
  id: string;
  name: string;
  price: number;
  unit: 'szt' | 'm²' | 'mb' | 'komplet' | 'special';
  icon: React.ComponentType<any>;
}

export const additionalOptions: AdditionalOption[] = [
  // GRAFIKA - zaktualizowane ceny
  { id: 'grafika', name: 'Grafika jednostronna', price: 75, unit: 'm²', icon: FileText }, // zmienione ze 100 na 75
  { id: 'grafika_dwustronna', name: 'Grafika dwustronna', price: 150, unit: 'm²', icon: FileText }, // zmienione ze 160 na 150
  
  // OBRÓBKA
  { id: 'polerowanie', name: 'Polerowanie krawędzi', price: 9, unit: 'mb', icon: Sparkles }, // zmienione z 15 na 9
  
  // OPAKOWANIE
  { id: 'karton', name: 'Opakowanie kartonowe', price: 8, unit: 'm²', icon: Package },
  
  // OKUCIA - zaktualizowane ceny
  { id: 'zawiasy', name: 'Zawiasy', price: 18, unit: 'komplet', icon: Link }, // zmienione z 45 na 18
  { id: 'zamek', name: 'Zamek', price: 18, unit: 'szt', icon: Lock }, // zmienione z 35 na 18
  
  // DYSTANSE
  { id: 'nozki', name: 'Nóżki dystansowe', price: 25, unit: 'komplet', icon: CircleDot },
  
  // LED
  { id: 'led_standard', name: 'LED Standard', price: 30, unit: 'mb', icon: Lightbulb },
  { id: 'led_cob', name: 'LED COB', price: 55, unit: 'mb', icon: Lightbulb },
  { id: 'led_rgb', name: 'LED RGB', price: 80, unit: 'mb', icon: Lightbulb },
  { id: 'zasilacz_led', name: 'Zasilacz LED', price: 80, unit: 'szt', icon: Zap },
  { id: 'projekt_led', name: 'Projekt oświetlenia LED', price: 0, unit: 'special', icon: Lightbulb },
  { id: 'wodoodpornosc', name: 'Wodoodporność LED', price: 0, unit: 'special', icon: Droplets },
  
  // KLEJENIE
  { id: 'klejenie_uv', name: 'Klejenie UV', price: 0, unit: 'special', icon: Shield },
  
  // ELEMENTY KONSTRUKCYJNE
  { id: 'wieko', name: 'Wieko/pokrywa', price: 0, unit: 'special', icon: Layers },
  { id: 'dno_inny_material', name: 'Dno z innego materiału', price: 0, unit: 'special', icon: Layers },
  
  // TOPERY - NOWA OPCJA z ceną 180 zł/m²
  { id: 'topper', name: 'Topper reklamowy', price: 0, unit: 'special', icon: Type }, // stara wersja
  { id: 'topper_grafika', name: 'Topper z grafiką', price: 180, unit: 'm²', icon: Type }, // NOWE - 180 zł/m²
  
  // EKSPOZYTORY
  { id: 'boki', name: 'Boki ekspozytora', price: 0, unit: 'special', icon: Package },
  
  // MONTAŻ
  { id: 'tasma', name: 'Taśma dwustronna', price: 5, unit: 'mb', icon: Package },
  
  // LITERY DO KASETONÓW - zaktualizowane ceny
  { id: 'litery_podklejane', name: 'Litery podklejane', price: 0, unit: 'special', icon: Type }, // w cenie (0 zł)
  { id: 'litery_zlicowane', name: 'Litery zlicowane', price: 200, unit: 'm²', icon: Type }, // zmienione z 50 na 200
  { id: 'litery_wystajace', name: 'Litery wystające', price: 400, unit: 'm²', icon: Type }, // zmienione z 80 na 400
  { id: 'litery_halo', name: 'Litery z efektem halo', price: 500, unit: 'm²', icon: Type } // zmienione ze 120 na 500
];

// Eksportuj też jako stałe dla łatwiejszego dostępu
export const PRICES = {
  // Grafika
  GRAFIKA_JEDNOSTRONNA: 75,      // zł/m²
  GRAFIKA_DWUSTRONNA: 150,       // zł/m²
  
  // Obróbka
  POLEROWANIE_KRAWEDZI: 9,       // zł/mb
  
  // Okucia
  ZAWIASY: 18,                   // zł/komplet
  ZAMEK: 18,                     // zł/sztuka
  
  // Topery
  TOPPER_Z_GRAFIKA: 180,         // zł/m²
  
  // Litery kasetonowe
  LITERY_PODKLEJANE: 0,          // w cenie (gratis)
  LITERY_ZLICOWANE: 200,         // zł/m²
  LITERY_WYSTAJACE: 400,         // zł/m²
  LITERY_HALO: 500,              // zł/m²
  
  // LED
  LED_STANDARD: 30,              // zł/mb
  LED_COB: 55,                   // zł/mb
  LED_RGB: 80,                   // zł/mb
  ZASILACZ_LED: 80,              // zł/sztuka
  
  // Opakowanie
  KARTON: 8,                     // zł/m²
  
  // Dystanse
  NOZKI: 25,                     // zł/komplet
  
  // Montaż
  TASMA_DWUSTRONNA: 5,           // zł/mb
};